import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    separator: css({
        border: "none",
        borderTopStyle: "solid",
    }),
    n400: css({
        borderTopColor: Color.neutral[400],
    }),
    n800: css({
        borderTopColor: Color.neutral[800],
    }),
    n200: css({
        borderTopColor: Color.neutral[200],
    }),
    n100: css({
        borderTopColor: Color.neutral[100],
    }),
});
